
import { Component, Getter, Prop, Vue, Provide } from 'nuxt-property-decorator'

@Component({
  name: 'CommonAcfHero',
})
export default class CommonAcfHero extends Vue {
  @Prop(String) readonly content: string
  @Provide() pageLoaded = false

  mounted() {
    setTimeout(() => {
      this.pageLoaded = true
    }, 0)
  }
}
